import { create } from 'zustand';
import { GetRegionsResponse } from '@/api/types/regions.types';

interface RegionsStore {
  regions: Partial<Record<string, GetRegionsResponse>>;
  setRegions: (language: string, regions: GetRegionsResponse) => void;
}

export const useRegionsStore = create<RegionsStore>(set => ({
  regions: {},
  setRegions: (lang, regions) =>
    set(state => ({
      regions: {
        ...state.regions,
        [lang]: regions,
      },
    })),
}));
